<template lang="pug">
yz-dialog(v-model="showDialog" persistent max-width="500px")
  yz-card
    yz-dialog-normal-header(title="Location has remaining stock" @close="onClose")
    yz-dialog-normal-content.px-6.py-6
      .d-flex.align-start.gap-2
        yz-icon.mt-1(color="yz-danger-500" size="20") $yzi-alert-circle
        .yz-medium-body-md.text-neutral-700 This location still has stock for this inventory.
      .yz-regular-body-sm.text-neutral-700.mt-2.ml-7 Please transfer or adjust stock to zero before unassigning. You cannot unassign this location until the stock is cleared.
    yz-dialog-normal-actions
      yz-btn(size="lg" label="Close" @click="onClose")
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  methods: {
    onClose() {
      this.showDialog = false
    }
  }
}
</script>
